<template>
  <div class="dynamic-sensing">
    <div class="dynamic-sensing__panel">
      <div class="dynamic-sensing__panel__header">
        {{ $t('detail.dynamic_sensing') }}
        <button class="btn-set-dynamic" @click="updateTentacle()">
          {{ $t('detail.set_dynamic_sensing') }}
        </button>
      </div>
      <div class="dynamic-sensing__panel__content">
        <div class="detail-settings">
            <div class="settings-row">
              <div class="left">
                <div class="settings-row__name__title">{{ $t('detail.payload_format') }}</div>
                <div class="settings-row__name__description" v-if="device.payload.updated !== null">{{ $t('detail.payload_format_updated') }}: {{ this.compDatetime(device.payload.updated) }}</div>
              </div>
              <div class="right">
                <div class="lqi-info" v-if="device.payload.ackType">{{device.payload.payloadFormats[device.payload.ackType].name}}</div>
              </div>
            </div>
            <div class="settings-row">
              <div class="left">
                <div class="settings-row__name__title" for="">{{ $t('detail.measurement_frame') }}:</div>
                <div class="settings-row__name__description" v-if="device.payload.changed !== null">{{ $t('detail.payload_format_changed') }}: {{ changedAt }}</div>
              </div>
              <div class="right">
                <select v-model="device.payload.userType">
                  <option v-for="(payloadFormat, type) in device.payload.payloadFormats"
                          :value="type"
                          :key="payloadFormat.name"
                          :selected="selectedFormat">
                      {{ payloadFormat.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="settings-row">
                <label for="userMessagesInInterval">{{ $t('detail.measurement_sets') }}:</label>
                <select name="userMessagesInInterval" v-model="device.payload.userMessagesInInterval" id="userMessagesInInterval">
                    <option v-for="value of accMeasurementsSets" v-bind:key="value" :value="value">{{ value }}</option>
                </select>
            </div>
            <div class="settings-row">
                <label for="measurementInterval">{{ $t('detail.measurement_interval') }}:</label>
                <select name="measurementInterval" v-model="device.payload.userOmittedMessages" id="measurementInterval">
                    <option v-for="(value, index) of measurementIntervals" v-bind:key="index" :value="index">{{ value }}</option>
                </select>
            </div>
            <div class="settings-row">
                <label for="downlinkPeriod">{{ $t('detail.downlik_period') }}:</label>
                <select name="downlinkPeriod" v-model="device.payload.downlinkPeriod" id="downlinkPeriod">
                    <option v-for="period of downlinkPeriods" v-bind:key="period.value" :value="period.value">{{ period.label }}</option>
                </select>
            </div>
            <div class="settings-row">
                <label for="downlinkRetries">{{ $t('detail.downlink_retries') }}:</label>
                <select name="downlinkRetries" v-model="device.payload.downlinkRetries" id="downlinkRetries">
                    <option v-for="(value, index) of downlinkRetriesArray" v-bind:key="value" :value="value">{{ index }}</option>
                </select>
            </div>
            <div class="settings-row" v-if="!disabledTransmittingPower">
                <label for="transmittingPower">{{ $t('detail.transmitting_power') }}:</label>
                <select name="transmittingPower" v-model="device.payload.transmittingPower" id="transmittingPower">
                    <option v-for="(value, index) of transmittingPowerArray" v-bind:key="value" :value="value">{{ index }}</option>
                </select>
            </div>
            <div class="settings-row">
                <label for="message_interval">{{ $t('detail.message_interval') }}:</label>
                <input id="message_interval" name="message_interval" type="text" disabled :value="messageInterval">
            </div>
            <div class="settings-row">
                <label for="device_lifespan">{{ $t('detail.device_lifespan') }}:</label>
                <input id="device_lifespan" name="device_lifespan" type="text" disabled :value="deviceLifespan">
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatchSelection from '@/views/detail/BatchSelection.vue';
import versionService from '@/services/VersionServices';
// import store from '@/store';

export default {
  name: 'DetailSettingsRow',
  components: {
    BatchSelection,
    versionService
  },
  props: {
    device: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      downlinkRetriesArray: {"0":"0", "1":"1", "2":"2", "3":"3"},
      transmittingPowerArray: {"20%":"7","25%":"8","33%":"9","40%":"10","50%":"11","65%":"12", "80%":"13", "100% (default)":"14", "125%":"15"},
      modal: false,
      changedAt: this.compDatetime(this.device.payload.changed),
    };
  },
  computed: {
    accMeasurementsSets: function () {
      let range = [];

      if (Object.prototype.hasOwnProperty.call(this.device.payload.payloadFormats, this.device.payload.userType)) {
        range = this.device.payload.payloadFormats[this.device.payload.userType].options;
      }

      if (!range.includes(parseInt(this.device.payload.userMessagesInInterval))) {
        this.device.payload.userMessagesInInterval = range[0];
      }

      return range;
    },
    downlinkPeriods: function () {
      if (parseInt(this.device.payload.userOmittedMessages) === 0 && parseInt(this.device.payload.userMessagesInInterval) === 1) {
        if (parseFloat(this.device.payload.downlinkPeriod) === 0.25) {
          this.device.payload.downlinkPeriod = 0.50;
        }
        return [
          {
            label: this.$t('detail.once_per_two'),
            value: 0.50,
          },
          {
            label: this.$t('detail.once_per_day'),
            value: 1,
          },
          {
            label: this.$t('detail.twice_per_day'),
            value: 2,
          },
        ]
      } else if (parseInt(this.device.payload.userType) === 6 && parseInt(this.device.payload.userMessagesInInterval) === 6) {
        this.device.payload.downlinkPeriod = 1;
        return [{label: this.$t('detail.once_per_day'), value: 1}];
      } else if (parseInt(this.device.payload.userType) === 6 && parseInt(this.device.payload.userMessagesInInterval) === 12) {
        this.device.payload.downlinkPeriod = 0.5;
        return [{label: this.$t('detail.once_per_two'), value: 0.5}];
      } else {
        return [
          {
            label: this.$t('detail.once_per_four'),
            value: 0.25,
          },
          {
            label: this.$t('detail.once_per_two'),
            value: 0.50,
          },
          {
            label: this.$t('detail.once_per_day'),
            value: 1,
          },
          {
            label: this.$t('detail.twice_per_day'),
            value: 2,
          },
        ]
      }
    },
    measurementIntervals: function () {
      if (parseInt(this.device.payload.userType) === 6) {
        this.device.payload.userOmittedMessages = 15;
        return {15: 240};
      }

      const range = {};
      for (let i = 0; i <= 15; i += 1) {
        range[i] = (i + 1) * 15;
      }
      return range;
    },
    messageInterval: function () {
      return ((parseInt(this.device.payload.userOmittedMessages) + 1) * 15) * parseInt(this.device.payload.userMessagesInInterval);
    },
    deviceLifespan: function () {
      const maxMeasurments = {
        1: 3,
        2: 5,
        3: 4,
        4: 10,
        5: 4,
        6: 15,
      };

      var messageRatio = parseInt(this.device.payload.userMessagesInInterval) / maxMeasurments[this.device.payload.userType];  // maxMeasurementsInFrame is variable defining maximum measurement sets in current frame. It changes when different frame is selected.
      let messageConsumptionValue = 0.23424;
      if (messageRatio < 0.32) {
          messageConsumptionValue = 0.169824;
      } else if (messageRatio < 0.65) {
          messageConsumptionValue = 0.20496;
      }
      const version = this.device.version;

      const messageIntervalValue = parseInt(this.messageInterval);
      const downlinkPeriodValue = parseFloat(this.device.payload.downlinkPeriod);
      const txPowerValue = this.device.payload.transmittingPower;
      const txCoefficientValue = 0.00137 * Math.pow(txPowerValue, 3) - 0.03852 * Math.pow(txPowerValue, 2) + 0.4025 * txPowerValue - 0.8054;

      let lifeSpan = NaN;

      if (version && version.batteryFormula){
        lifeSpan = eval(version.batteryFormula);
      }

      if (isNaN(lifeSpan)) {
        return (5040 / ((1.380821918 + (1440 / parseInt(this.messageInterval)) * messageConsumptionValue + 0.20528 * parseFloat(this.device.payload.downlinkPeriod)) * 365)).toFixed(1);
      }

      return lifeSpan.toFixed(1);
    },
    selectedFormat() {
      return 1;
    },
    disabledTransmittingPower() {
      return versionService.disabledTransmittingPower(this.device.version);
    },
  },
  methods: {
    compDatetime(timestamp) {
      const newDate = new Date(Number(timestamp) * 1000);
      //let utcDate = this.getUtcDateTime(newDate);
      this.moment.locale(this.$i18n.locale.toLowerCase());
      return this.moment(newDate).format(this.timeFormat ? 'DD MMM YYYY hh:mm a' : 'DD MMM YYYY HH:mm');
    },
    getUtcDateTime(date){
      return new Date(date.getUTCFullYear(),date.getUTCMonth(),date.getUTCDate(),date.getUTCHours(),date.getUTCMinutes(),date.getUTCSeconds());
    },
    isUserDealer() {
      let user = this.$store.getters['tentacle/user'];
      return user ? user.is_dealer : false;
    },
    updateTentacle() {
      const data = [{
        id: this.device.id,
        userPayloadFormatType: this.device.payload.userType,
        userMessagesInInterval: this.device.payload.userMessagesInInterval,
        userOmittedMessages: this.device.payload.userOmittedMessages,
        downlinkPeriod: this.device.payload.downlinkPeriod,
        downlinkRetries: this.device.payload.downlinkRetries,
        transmittingPower: this.device.payload.transmittingPower,
      }];

      this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
        if (response.status === 200) {
            this.flash('Tentacles updated', 'success');
            this.$store.dispatch('tentacle/setUnitByID', this.device.id).then((response) => {
                if (response.status === 200) {
                    this.changedAt = this.compDatetime(response.data.payload.changed);
                }
            });
        }
      });
    },
  },
  mounted () {
    //console.log(this.device)
  }
};
</script>

<style lang="scss" scoped>
.dynamic-sensing {
  margin-top: 4rem;
  padding-left: 8rem;
    @media only screen and (max-width: 990px) {
        padding-left: 0;
        width: 90%;
        margin-right: auto;
        margin-left: 5%;
    }
    @media only screen and (min-width: 991px) and (max-width: 1199px) {
        padding-left: 0;
        width: 90%;
        margin-right: auto;
        margin-left: 5%;
    }
    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
        margin-left: -4%;
        width: 100%;
    }

  &__panel {
    border-radius: 2rem;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
    position: relative;

    .loading-wrapper {
      position: absolute;
      top: 5rem;
      width: 100%;
      height: calc(100% - 10rem);
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
    }

    &__header {
      padding: 0 3rem;
      height: 6rem;
      border-bottom: 0.1rem solid $border-color;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 1.4rem;
      color: $grey;

      button {
        width: 150px;
        color: #f7f7f7;
        margin-left: auto;
        margin-top: 0.5rem;
        background-color: $company-color;
        border: none;
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 2.8rem;
        cursor: pointer;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
      }
    }

    &__content {
      padding: 2rem 3rem;
      font-size: 1.3rem;
      @media only screen and (max-width: 1400px) {
        min-height: 26rem;
      }
    }
  }

    .detail-settings {
        .settings-row {
            display: flex;
            justify-content: space-between;
            padding: 0;

            .lqi-info {
              margin-left: auto;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              padding: 10px 15px;
              line-height: 20px;
              font-size: 15px;
              font-weight: 500;
            }

            select {
              max-width: 20rem;
            }

            &:last-of-type {
              border-bottom: 0;
            }

            input {
                border: 1px solid $border-color;
                color: $middle-grey;
                background-color: $bg;
                border-radius: 3px;
                line-height: 2rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;
                max-width: 20rem;
            }
        }
    }
}

</style>
